<div class="collapsible-section" [ngClass]="{ 'is-open': isOpen }">
  <button
    type="button"
    class="toggle-button"
    trackable
    [trackingObject]="trackingObject"
    [trackingAction]="trackingAction"
    (click)="toggleVisibility()"
  >
    <div class="toggle-button-contents">
      <span class="toggle-icon-wrapper">
        <app-icon *ngIf="icon" [icon]="icon"> </app-icon>
      </span>

      <span class="toggle-button-text">
        {{ header }}
      </span>
    </div>
  </button>

  <div class="section">
    <ng-content></ng-content>
  </div>
</div>
